import '@mdi/font/css/materialdesignicons.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VStepperVertical, VStepperVerticalItem } from 'vuetify/labs/VStepperVertical'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import bensisTheme from './vuetify/theme'

export default createVuetify({
  defaults: {
    VContainer: {
      fluid: true
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: 'bensisTheme',
    themes: {
      bensisTheme
    }
  },
  components: {
    ...components,
    VStepperVertical,
    VStepperVerticalItem,
    VDateInput
  },
  directives
})
